import { Platform } from 'react-native';

/**
 * A locale is a set of options that describe the user's language, time zone, etc.
 *
 * @example
 * ```json
 * {
 *   locale: 'en-US',
 *   timeZone: 'America/Los_Angeles',
 * }
 * ```
 */
export type Locale = {
  locale: string;
  timeZone: string;
};

export function useLocale(): Locale | undefined {
  let locale: Locale | undefined;
  if (Platform.OS === 'web') {
    const opts = Intl.DateTimeFormat().resolvedOptions();
    return {
      locale: opts.locale,
      timeZone: opts.timeZone,
    };
  } else {
    // TODO: On native, we'll need to use something like react-native-localize.
  }
  return locale;
}
